import { render, staticRenderFns } from "./aria-labelled-by.vue?vue&type=template&id=00a930b7&"
import script from "./aria-labelled-by.vue?vue&type=script&lang=js&"
export * from "./aria-labelled-by.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports